// Mass Flux Density units with conversion factors to kilogram-per-second-square-meter (kg/(s·m²))
export const massFluxDensityUnits = [
  { id: 'kilogram-per-second-square-meter', name: 'Kilogram per Second per Square Meter', symbol: 'kg/(s·m²)', plural: 'Kilograms per Second per Square Meter', factor: 1 },
  { id: 'kilogram-per-hour-square-meter', name: 'Kilogram per Hour per Square Meter', symbol: 'kg/(h·m²)', plural: 'Kilograms per Hour per Square Meter', factor: 1/3600 },
  { id: 'gram-per-second-square-meter', name: 'Gram per Second per Square Meter', symbol: 'g/(s·m²)', plural: 'Grams per Second per Square Meter', factor: 0.001 },
  { id: 'gram-per-second-square-centimeter', name: 'Gram per Second per Square Centimeter', symbol: 'g/(s·cm²)', plural: 'Grams per Second per Square Centimeter', factor: 10 },
  { id: 'kilogram-per-hour-square-foot', name: 'Kilogram per Hour per Square Foot', symbol: 'kg/(h·ft²)', plural: 'Kilograms per Hour per Square Foot', factor: 1/(3600 * 0.09290304) },
  { id: 'pound-per-hour-square-foot', name: 'Pound per Hour per Square Foot', symbol: 'lb/(h·ft²)', plural: 'Pounds per Hour per Square Foot', factor: 0.45359237/(3600 * 0.09290304) },
  { id: 'pound-per-second-square-foot', name: 'Pound per Second per Square Foot', symbol: 'lb/(s·ft²)', plural: 'Pounds per Second per Square Foot', factor: 0.45359237/0.09290304 },
  { id: 'gram-per-second-square-millimeter', name: 'Gram per Second per Square Millimeter', symbol: 'g/(s·mm²)', plural: 'Grams per Second per Square Millimeter', factor: 1000 },
];

export const popularMassFluxDensityConversions = [
  { from: 'kilogram-per-second-square-meter', to: 'kilogram-per-hour-square-meter' },
  { from: 'kilogram-per-hour-square-meter', to: 'kilogram-per-second-square-meter' },
  { from: 'kilogram-per-second-square-meter', to: 'gram-per-second-square-meter' },
  { from: 'pound-per-hour-square-foot', to: 'kilogram-per-hour-square-meter' },
  { from: 'kilogram-per-hour-square-meter', to: 'pound-per-hour-square-foot' },
  { from: 'gram-per-second-square-centimeter', to: 'kilogram-per-second-square-meter' },
];

export const getUnitById = (id) => massFluxDensityUnits.find(unit => unit.id === id);

export const convertMassFluxDensity = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert mass flux density units and learn the conversion formula.`;
};
